/* istanbul ignore file */
import React from 'react';
import { setLocaleCookies } from '@noths/polaris-client-localisation';
import { BaseApp, BaseAppProps } from '@noths/polaris-client-next-components';
import { SkipLinks } from '@noths/polaris-client-site-chrome-ui';
import { AppContextPlusCookies } from '@noths/polaris-dev-ts-types';
import NextApp, { AppInitialProps, AppProps } from 'next/app';
import getConfig from 'next/config';
import Head from 'next/head';

import { PreviewMode } from 'src/components/molecules/PreviewMode';
import { APP_STORE_ID } from 'src/constants/pageAttributes';
import { getExperiments } from 'src/utils/getExperiments';
import { logger } from 'src/utils/serverLogger';
import { MAIN_CONTENT_WRAPPER } from '../constants/elementIds';

const config = getConfig();
const AppComponent = BaseApp(config);

const App = (props: AppProps & BaseAppProps) => {
  const {
    pageProps: { isPreview, topBannerData },
  } = props;

  return (
    <>
      <Head>
        <meta name="apple-itunes-app" content={`app-id=${APP_STORE_ID}`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="shortcut icon" href={`${config.publicRuntimeConfig.CDN_URL}/favicon.ico`} />
      </Head>
      {isPreview && <PreviewMode />}
      <SkipLinks links={[{ content: 'Skip to content', sectionId: MAIN_CONTENT_WRAPPER }]} />
      <AppComponent {...props} topBannerData={topBannerData} />
    </>
  );
};

App.getInitialProps = async (
  appContext: AppContextPlusCookies,
): Promise<AppInitialProps & BaseAppProps> => {
  const {
    ctx: { req, res },
  } = appContext;

  if (req && res) {
    setLocaleCookies({ req, res, logger });
  }

  const experiments = (req && getExperiments(req)) ?? '';
  const appProps = await NextApp.getInitialProps(appContext);

  return { ...appProps, experiments };
};

export default App;
